// extracted by mini-css-extract-plugin
export default {"progressBar":"styles_progressBar__EgziG","progressBar__fill":"styles_progressBar__fill__3eXHw","progressBar__text":"styles_progressBar__text__y179m"};